import React, { useEffect, lazy, Suspense, useContext, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";

const Home = lazy(() => import("./pages/Home"));
const Login = lazy(() => import("./pages/Login"));
const Signup = lazy(() => import("./pages/Signup"));
const Landing = lazy(() => import("./pages/Landing"));
const CustomerForm = lazy(() => import("./pages/CustomerForm"));
const ITRForm = lazy(() => import("./pages/ITRForm"));
const ITRHistory = lazy(() => import("./pages/ITRHistory"));
const Subadmin = lazy(() => import("./pages/Subadmin"));
const Ca = lazy(() => import("./pages/Ca"));
const Superadmin = lazy(() => import("./pages/Superadmin"));
const SubadminDashboard = lazy(() => import("./pages/SubadminDashboard"));
const SubadminCustomers = lazy(() => import("./pages/SubadminCustomers"));
const SubadminAgents = lazy(() => import("./pages/SubadminAgents"));
// const SubadminSettings = lazy(()=>import("./pages/SubadminSettings"));
const SubadminReports = lazy(() => import("./pages/SubadminReports"));
const SubadminChatSystem = lazy(() => import("./pages/SubadminChatSystem"));
const SubadminEverificationOtpcheck = lazy(() => import("./pages/SubadminEverificationOtpcheck"));
const CaReports = lazy(() => import("./pages/CaReports"));


function App() {
  const location = useLocation();
  const { user, loading, login, logout, isCollapsed } = useContext(AuthContext);
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);

  useEffect(() => {
    if (user && user.isagent === 'unverified') {
      setShowVerificationPopup(true);
    } else {
      setShowVerificationPopup(false);
    }
  }, [user]);

  useEffect(() => {
    // Cleanup function
    return () => {
      // Add any cleanup logic here if needed
    };
  }, [location.pathname]);

  if (loading) {
    return <div className="w-full h-screen bg-[#1e1e1e] flex justify-center items-center text-white text-2xl">Loading...</div>;
  }

  return (
    <Suspense fallback={<div className="w-full h-screen bg-[#1e1e1e] flex justify-center items-center text-white text-2xl">Loading...</div>}>
      <div className={isCollapsed ? "sidebar-collapsed" : ""}>
        {location.pathname !== '/login' && location.pathname !== '/signup' && location.pathname !== '/landing' && <Navbar />}
        {showVerificationPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm text-center">
              <h2 className="text-xl font-bold mb-4">Verification Pending</h2>
              <p>Your agent account is currently unverified. Please wait for verification.</p>
              <button
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                onClick={() => setShowVerificationPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}
        <Routes>
          {!user ? (
            <>
              <Route path="/login" element={<Login onLogin={login} />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/landing" element={<Landing />} />
              <Route path="*" element={<Navigate to="/landing" replace />} />
            </>
          ) : user.issuperadmin ? (
            <>
              <Route path="/superadmin" element={<Superadmin />} />
              <Route path="/superadmin/agents" element={<Superadmin />} />
              <Route path="/superadmin/subadmins" element={<Superadmin />} />
              <Route path="/superadmin/cas" element={<Superadmin />} />
              <Route path="/superadmin/customers" element={<Superadmin />} />
              <Route path="/superadmin/payments" element={<Superadmin />} />
              <Route path="/superadmin/reports" element={<Superadmin />} />
              <Route path="/superadmin/customer-form-fields" element={<Superadmin />} />
              <Route path="/superadmin/ITR" element={<Superadmin />} />
              <Route path="/superadmin/wallets" element={<Superadmin />} />
              <Route path="/superadmin/chat-rooms" element={<Superadmin />} />
              <Route path="/superadmin/ratecard" element={<Superadmin />} />
              <Route path="*" element={<Navigate to="/superadmin" replace />} />
            </>
          ) : user.issubadmin ? (
            <>
              {/* <Route path="/subadmin" element={<SubadminDashboard />} /> */}
              <Route path="/subadmin/customers" element={<SubadminCustomers />} />
              <Route path="/subadmin/agents" element={<SubadminAgents />} />
              {/* <Route path="/subadmin/settings" element={<SubadminSettings />} /> */}
              <Route path="/subadmin/reports" element={<SubadminReports />} />
              <Route path="/subadmin/settings" element={<SubadminChatSystem />} />
              <Route path="/subadmin/everification-otpcheck" element={<SubadminEverificationOtpcheck />} />
              <Route path="*" element={() => window.location.href = "/subadmin/customers"} />
            </>
          ) : user.isca ? (
            <>
              <Route path="/ca" element={<Ca />} />
              <Route path="/ca/reports" element={<CaReports />} />
              <Route path="*" element={<Navigate to="/ca" replace />} />
            </>
          ) : (
            <>
              <Route path="/ca" element={<Ca />} />
              {/* <Route path="/" element={<Home />} /> */}
              <Route path="/itr-application" element={<Home />} />
              <Route path="/customer" element={<Home />} />
              <Route path="/wallet" element={<Home />} />
              <Route path="/customer-form" element={<CustomerForm />} />
              <Route path="/itr" element={<ITRForm />} />
              <Route path="/itr-history" element={<ITRHistory />} />
              {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
            </>
          )}
        </Routes>
      </div>
    </Suspense>
  );
}

export default function AppWrapper() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}
